const checkmarkIcon = `
<svg xmlns="http://www.w3.org/2000/svg" focusable="false" width="16" height="15" viewBox="0 0 16 15">
    <path fill="none" fill-rule="evenodd" stroke="#00AAE2" stroke-width="2" d="M138 23L128.084 35 124 29.863" transform="translate(-123 -22)"/>
</svg>
`;

export default checkmarkIcon;
